import styled from 'styled-components';

interface ContainerProps {
	hasIcon?: boolean;
}

export const CustomSelectContainer = styled.div<ContainerProps>`
	position: relative;

	.custom-arrow-icon {
		opacity: 1;
		transition: opacity 0.3s ease;
	}
	&:hover .custom-arrow-icon {
		opacity: 0;
	}

	.ant-select-selector {
		border-radius: 4px !important;
		${({ hasIcon }) => hasIcon && `padding-left: 36px !important;`}
	}

	.custom-edit-icon {
		position: absolute;
		left: 8px;
		top: 50%;
		transform: translateY(-50%);
		font-size: 16px;
		z-index: 2;
		pointer-events: auto;
	}

	.custom-arrow-icon {
		position: absolute;
		right: 11px;
		top: 50%;
		transform: translateY(-50%);
		pointer-events: none;
		color: #aaa;
		font-size: 12px;
		z-index: 2;
		opacity: 1;
		transition: opacity 0.2s ease;
	}
	&.hovering .custom-arrow-icon {
		opacity: 0;
	}
`;

export const TagWrapper = styled.span`
	background: #f5f5f5;
	border-radius: 6px;
	padding: 0 8px;
	margin-right: 3px;
	margin-bottom: 3px;
	display: flex;
	align-items: center;
	font-weight: 500;
`;

export const CloseButton = styled.span`
	cursor: pointer;
	margin-left: 6px;
	color: #aaa;
	font-weight: 700;
`;

export const ItemWrapper = styled.span`
	display: flex;
	align-items: center;
`;

export const Label = styled.span`
	margin-left: 8px;
`;

export const DropdownWrapper = styled.div`
	.ant-select-dropdown {
		padding: 0 !important;
	}

	.ant-checkbox-wrapper {
		transform: scale(0.8);
		margin-right: 8px;
	}

	.ant-select-item-option-state {
		display: none;
	}

	.rc-virtual-list-holder-inner > div.ant-select-item-option {
		border-bottom: 1px solid #e6e6e6;
	}

	.rc-virtual-list-holder-inner > div.ant-select-item-option:last-child {
		border-bottom: none;
	}

	.ant-select-item-option-content {
		padding: 4px 8px;
	}

	.ant-select-item-option-selected .ant-select-item-option-content,
	.ant-select-item-option-active .ant-select-item-option-content {
		font-weight: normal;
		color: #002fbb;
	}

	.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
		color: #b0bfea;
		font-weight: 600;
		background-color: #e6eaf8;
	}
`;
